import {BaseConfig} from "../../infrastructure/config/base-config";
import {NewsWidgetTerms} from "./news-widget.terms";

export class NewsWidgetConfig extends BaseConfig {
  static injectables = [NewsWidgetTerms];

  constructor(terms: NewsWidgetTerms) {
    super('NewsWidget', null, terms);
  }
}
